module.exports = __webpack_public_path__ + "img/black.3fe8130c.png";